import InfoCourseCard from "@components/UI/InfoCourseCard";
import s from "./styles.module.sass";
import { useStore } from "effector-react";
import { $course } from "@features/Course/model/public";
import { $instructorCourses } from "@components/views/Instructor/model/public";

const OtherAuthorCourses = () => {
	const authorCourses = useStore($instructorCourses);
	const course = useStore($course);

	const filteredCoursesByAuthorExceptCurrentOne =
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		authorCourses?.items.filter((authorCourse) => {
			return authorCourse.url !== course?.url;
		}) || [];

	return filteredCoursesByAuthorExceptCurrentOne.length > 0 ? (
		<>
			<h2>Другие курсы этого автора</h2>
			<div className={s.otherCourses}>
				{
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					filteredCoursesByAuthorExceptCurrentOne.map((course, index) => {
						return <InfoCourseCard key={index} variant="horizontal" course={course} />;
					})
				}
			</div>
		</>
	) : null;
};

export default OtherAuthorCourses;
